import { render, staticRenderFns } from "./CoinDealsList.vue?vue&type=template&id=3d707dbc&scoped=true&"
import script from "./CoinDealsList.vue?vue&type=script&lang=ts&"
export * from "./CoinDealsList.vue?vue&type=script&lang=ts&"
import style0 from "./CoinDealsList.vue?vue&type=style&index=0&id=3d707dbc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d707dbc",
  null
  
)

export default component.exports